class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      if (this.closest('[data-bundleid]')) {
       // alert('true');
          var getattrbundleid = this.closest('[data-bundleid]').getAttribute('data-bundleid');
          var getattrbund = this.closest('[data-bundleid]').getAttribute('data-itemkey');
        console.log(getattrbundleid + ' / ' + getattrbund);
          cartItems.updateQuantity(this.dataset.index, 0, '', '', 'SwymGrBtnForRemove', getattrbundleid, getattrbund);
      } else {
          cartItems.updateQuantity(this.dataset.index, 0);
        //alert('false');
        
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId, SwymGrBtnForRemove, BundleID, ItemKey) {    
    this.enableLoading(line);
    var thisM = this;
    const loaderItg = () => {
      thisM.enableLoading(line);
    }
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        
        const parsedState = JSON.parse(state);
        //  console.log(parsedState.original_total_price,'state',parsedState)
        // const totalPrice = document.querySelectorAll('p.totals__total-value');
        // totalPrice.forEach(function(totalPrice_){
        //   var price = Shopify.formatMoney(parsedState.original_total_price,window.theme.moneyWithCurrencyFormat)
        //   console.log(price,'price')
        //   totalPrice_.innerText = price;
        // });

          fetch(`${window.location.pathname}?section_id=main-cart-items`)
            .then(res => res.text())
             .then(html => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              console.log('doc', doc)
              const newSavings = doc.querySelector('.wrap_savings_hidden');
              const savingsCart = document.querySelector('.wrap_savings_cart');
              // console.log('newSavings', newSavings)
              // if (newSavings) {
              //   document.querySelector('.wrap_savings_cart').innerHTML = newSavings.innerHTML;
              // }
              if (savingsCart) {
                if (newSavings) {
                  savingsCart.innerHTML = newSavings.innerHTML;
                  savingsCart.style.display = "flex"; 
                } else {
                  savingsCart.style.display = "none";
                }
              }

              const newTotalPrice = doc.querySelector('p.totals__total-value');
              console.log('newTotalPrice', newTotalPrice)
                if (newTotalPrice) {
                  document.querySelectorAll('p.totals__total-value').forEach(el => {
                    el.innerHTML = newTotalPrice.innerHTML;
                  });
                }
            });

        var uk_content_selector = document.querySelectorAll('.itg-ctm-show-cnt p');
        if (uk_content_selector.length > 0 && parsedState.original_total_price > 0) { 
          uk_content_selector.forEach(function(paragraph) {
            if (parsedState.original_total_price <= 13500) {                    
              paragraph.innerText = "Good news! No customs duty will be charged on your order, as it's under £135. Please note, import VAT may apply, which will be handled by local customs.";           
            } else {
              paragraph.innerText = "Your order exceeds £135, so customs duty and import VAT may apply. These charges will be managed by local customs, and you'll be notified directly from the courier for this payment.";
            }
          });
        }else{
         uk_content_selector.forEach(function(elem) {
            elem.style.display = 'none';
         });
        }
        
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {


        if (SwymGrBtnForRemove === 'SwymGrBtnForRemove') {
          var timerRemove = 250;
          console.log('.cart-item[data-bundleid="' + BundleID + '"]');
          console.log(timerRemove);
          var totalItems = $('.cart-item[data-bundleid="' + BundleID + '"]').length;
          $(document).find('body').addClass("CartLoader");
          setTimeout(function() {
      
      
              var EachLineItmKeyArray = [];
              $('.cart-item[data-bundleid="' + BundleID + '"]').each(function(index) {
                  var EachLineItmKey = $(this).attr('data-itemkey');
                  EachLineItmKeyArray.push("" + EachLineItmKey + ", " + 0 + "");
              });
              var updates = {};
              EachLineItmKeyArray.forEach(function(item) {
                  var parts = item.split(', ');
                  var id = parts[0];
                  var quantity = parts[1];
                  updates[id] = quantity;
              });
              $.ajax({
                  url: '/cart/update.js',
                  method: 'POST',
                  data: {
                      updates: updates
                  },
                  success: function(cart) {
                      console.log('Items removed successfully');
                      window.location.reload(); // Reload the page to reflect the changes
                  },
                  error: function(error) {
                      console.error('Error removing items from the cart:', error);
                  }
              });
          }, 500);
          // return false;
      }




        
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
